import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useState,
  useEffect,
} from 'react'

import { Button, Col, Form, PageHeader, Row } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import TextBox from 'Components/Form/TextBox'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import WsDocasService from 'Services/WS_DOCAS'

interface IProps {
  cdAlertaOcorrencia: number
  nomeAlerta: string
  setJustificarAlerta: Dispatch<SetStateAction<boolean>>
  justificativaAnterior?: string
}

interface Justificativa {
  texto: string
}

const ModalJustificativaAlerta = ({
  cdAlertaOcorrencia,
  nomeAlerta,
  setJustificarAlerta,
  justificativaAnterior,
}: IProps): ReactElement => {
  const [tamanhoJustificativa, setTamanhoJustificativa] = useState<number>(
    justificativaAnterior?.length ?? 0,
  )
  const [tamanhoMinimoJustificativa] = useState<number>(10)
  const [formulario] = Form.useForm<Justificativa>()
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  useEffect(() => {
    if (justificativaAnterior) {
      formulario.setFieldsValue({ texto: justificativaAnterior })
    }
  }, [])

  const justificaAlerta = async (justificativa: Justificativa) => {
    const { data } = await WsDocasService.alerta.justify(ID_COMPONENTE.DOCAS, {
      cdAlertaOcorrencia: cdAlertaOcorrencia,
      cdUsuario: applicationContext.usuarioAtual?.cdUsuario ?? 0,
      justificativa: justificativa.texto,
    })

    if (data?.statusCode === 200 || data?.statusCode === 501) {
      setJustificarAlerta(false)
    }
  }

  return (
    <Form onFinish={justificaAlerta} layout="vertical" form={formulario}>
      <PageHeader
        ghost={false}
        title={'Justificar Alerta: ' + nomeAlerta}
        extra={[
          <Button
            key="justificaAlerta"
            type="primary"
            htmlType="submit"
            disabled={tamanhoJustificativa < tamanhoMinimoJustificativa}
          >
            Justificar
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <TextBox
              name="texto"
              label="Justificativa:"
              rows={18}
              minimumLength={tamanhoMinimoJustificativa}
              length={tamanhoJustificativa}
              setLength={setTamanhoJustificativa}
            />
          </Col>
        </Row>
      </PageHeader>
    </Form>
  )
}

export default ModalJustificativaAlerta
